module.exports = __webpack_public_path__ + "img/reading-guide.e94ad900.png";